module.exports = __webpack_public_path__ + "static/media/07.ca590901.png";